import { AlpineComponent } from "alpinejs";
import { BasketService } from "../api";

type BuyButton = AlpineComponent<{
	quantity: number;
	addToCart: () => void;
	increment: () => void;
	decrement: () => void;
	sanitize: () => void;
}>;

export default (partNo: string): BuyButton => {
	return {
		quantity: 1,

		addToCart() {
			this.sanitize();

			BasketService.addToBasket({ body: { partNo: partNo, quantity: this.quantity } });
		},
		increment() {
			this.quantity += 1;
		},
		decrement() {
			if (this.quantity > 1) {
				this.quantity -= 1;
			}
		},
		sanitize() {
			if (this.quantity < 1 || isNaN(this.quantity)) {
				this.quantity = 1;
			} else {
				this.quantity = Math.floor(this.quantity);
			}
		},
	};
};
